module.exports = __webpack_public_path__ + "static/media/gospooky.d80180bf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/gospooky.webp
// module id = 541
// module chunks = 0